import React, { useContext } from 'react';
import { LocaleContext } from '../i18n/LocaleContext';
import { StaticQuery, graphql } from 'gatsby';
import config from '../../config';
import { Sidebar, ListItem } from './styles/Sidebar';

const SidebarLayout = ({ location, locale }) => {
  const { t } = useContext(LocaleContext);
  return (
  <StaticQuery
    query={graphql`
      query {
        allMdx {
          edges {
            node {
              fields {
                slug
                locale
              }
              tableOfContents
            }
          }
        }
      }
    `}
    render={({ allMdx }) => {
      let finalNavItems;

      const normalizePath = (path) => {
        return path.endsWith('/') ? path.slice(0, -1) : path;
      };

      const currentLocale = locale || 'en-GB';
      const filteredEdges = allMdx.edges.filter(
        ({ node }) => node.fields.locale === currentLocale
      );

      if (filteredEdges !== undefined && filteredEdges.length > 0) {
        filteredEdges.forEach((item) => {
          if (
            item !== undefined &&
            location !== undefined &&
            (normalizePath(item.node.fields.slug) === normalizePath(location.pathname) ||
              normalizePath(config.gatsby.pathPrefix + item.node.fields.slug) === normalizePath(location.pathname))
          ) {
            const addItems = (items, level = 1) => {
              return items.map((innerItem, index) => {
                const itemId = innerItem.title
                  ? innerItem.title.replace(/\s+/g, '').toLowerCase()
                  : '#';

                const children = innerItem.items
                  ? addItems(innerItem.items, level + 1)
                  : null;

                return (
                  <React.Fragment key={index}>
                    <ListItem to={`#${itemId}`} level={level}>
                      {innerItem.title}
                    </ListItem>
                    {children}
                  </React.Fragment>
                );
              });
            };

            if (item.node.tableOfContents.items) {
              finalNavItems = addItems(item.node.tableOfContents.items);
            }
          }
        });
      }

      if (finalNavItems && finalNavItems.length) {
        return (
          <Sidebar>
            <ul className={'rightSideBarUL'}>
              <li className={'rightSideTitle'}>{t('sidebar.onThisPage')}</li>
              {finalNavItems}
            </ul>
          </Sidebar>
        );
      } else {
        return (
          <Sidebar>
            <ul></ul>
          </Sidebar>
        );
      }
    }}
  />
  );
};

export default SidebarLayout;
